module.exports = __webpack_public_path__ + "img/switch.a0e49b10.png";